import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  Button,
  Tooltip
} from "@material-ui/core";
import { CopyToClipboard } from "react-copy-to-clipboard";

import {
  addCreative,
  resetCreativeState,
  selectCreative,
  deselectCreative
} from "../../actions/app/creatives";
import GeneratedName from "./GeneratedName";

import { fetchUserAdvertisers } from "../../services/dcm/advertisers";
import { insertRichMediaTemplates } from "../../services/dcm/creatives";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper
  },
  listItem: {
    wordBreak: "break-all"
  },
  copyButton: {
    flexShrink: 0,
    marginLeft: 10
  },
  button: {
    marginRight: 12
  }
}));

export default function GeneratedNamesList() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const creatives = useSelector((state) => state.creatives);
  const selectedList = creatives.selectedIds;
  const [userAdvertisers, setUserAdvertisers] = React.useState([]);
  const byId = creatives.byId;
  const [copied, setCopied] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  // const [lastSelectedIndex, setLastSelectedIndex] = React.useState(null);
  // const [selectedIndexList, setSelectedIndexList] = React.useState([]);

  useEffect(() => {
    dispatch(resetCreativeState());
  }, [dispatch]);

  useEffect(() => {
    fetchUserAdvertisers()
      .then((advertisersResponse) => setUserAdvertisers(advertisersResponse))
      .catch((err) => console.log(err));
  }, []);

  const copyToClipboard = () => {
    setCopied(true);
    handleTooltipOpen();
  };

  const handleTooltipOpen = () => {
    setOpen(true);
    setTimeout(() => setOpen(false), 1000);
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleListItemClick = (id) => {
    if (!selectedList.includes(id)) {
      dispatch(selectCreative(id));
    } else {
      dispatch(deselectCreative(id));
    }
  };

  return (
    <div className={classes.root}>
      <List component="nav">
        {Object.values(byId).map((creative, index) => (
          <ListItem
            key={index}
            button
            selected={selectedList.includes(creative.id)}
            onClick={() => handleListItemClick(creative.id)}
          >
            <ListItemText
              primary={
                creative.taxonomy.name ? creative.taxonomy.name : "»»»»»»»»»»»»"
              }
              className={classes.listItem}
            />
            <GeneratedName
              key={creative.id}
              creative={creative}
              index={index}
            />
          </ListItem>
        ))}
      </List>
      <Grid item container justify="flex-start">
        <Grid item>
          <Button
            variant="contained"
            className={classes.button}
            color="secondary"
            onClick={() => dispatch(addCreative())}
            disableElevation
          >
            Add new name
          </Button>
        </Grid>
        <Grid item>
          <CopyToClipboard
            onCopy={copyToClipboard}
            text={Object.values(byId).map((creative) =>
              creative.taxonomy.name ? creative.taxonomy.name : "»"
            )}
          >
            <Tooltip
              PopperProps={{
                disablePortal: true
              }}
              onClose={handleTooltipClose}
              open={open}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title="All names copied"
            >
              <Button
                variant="contained"
                className={classes.button}
                disableElevation
              >
                Copy all names
              </Button>
            </Tooltip>
          </CopyToClipboard>
        </Grid>
        {/* <Grid item>
          <Button
            variant="contained"
            className={classes.button}
            color="primary"
            onClick={() => insertRichMediaTemplates(
              userAdvertisers,
              Object.values(byId)
            )}
            disabled={creatives.allIds.length === 0}
            disableElevation
          >
            Submit Names
          </Button>
        </Grid> */}
      </Grid>
    </div>
  );
}
